module.exports = __webpack_public_path__ + "static/icons/icon-ski-lessons-961885c0b1c82aeb7b5b03778b724aa5.svg";